import { gsap} from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const init = () => {
  const parallaxElms = document.querySelectorAll('.js-jobguideParallax');
  if (!parallaxElms.length) return;

  window.addEventListener('load', () => {
    parallaxElms.forEach((elm) => {
      const img = elm.querySelector('picture');
      let percent = 20;
      gsap.fromTo(
        img,
        {
          yPercent: -percent / 2,
        },
        {
          yPercent: percent / 2,
          ease: "none",
          scrollTrigger: {
            name: "parallax",
            trigger: img,
            start: "top bottom",
            end: "bottom top",
            markers: false,
            scrub: true,
          },
        }
      );
    });
  });
}

export {
  init
}
